import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logoImage from '../media/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src={logoImage} alt="AuzLandRE Logo" className="logo-image" />
          </Link>
          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <Link 
              to="/" 
              className={location.pathname === '/buy' ? 'nav-link active' : 'nav-link'}
            >
              HOME
            </Link>
            <Link 
              to="/buy" 
              className={location.pathname === '/buy' ? 'nav-link active' : 'nav-link'}
            >
              PROPERTIES
            </Link>
            <Link 
              to="/about" 
              className={location.pathname === '/about' ? 'nav-link active' : 'nav-link'}
            >
              OUR STORY
            </Link>
            <Link 
              to="/blogs" 
              className={location.pathname === '/blogs' ? 'nav-link active' : 'nav-link'}
            >
              BLOGS
            </Link>
            <Link 
              to="/contact" 
              className={location.pathname === '/contact' ? 'nav-link active' : 'nav-link'}
            >
              CONTACT
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="header-cta">
             <a
               href="https://wa.me/61433933756" 
               target="_blank"
               rel="noopener noreferrer"
               className="whatsapp-btn"
              >
               <img 
                 src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                 alt="WhatsApp Chat"
                />
            </a>
            <Link to="/properties" className="btn btn-secondary">
              Login
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="mobile-menu-btn-div" >
            <a
               href="https://wa.me/61433933756" 
               target="_blank"
               rel="noopener noreferrer"
               className="whatsapp-btn"
              >
               <img 
                 src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                 alt="WhatsApp Chat"
                />
            </a>
            <button className="mobile-menu-btn" onClick={toggleMenu}>
                <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className={`nav-mobile ${isMenuOpen ? 'open' : ''}`}>
          <Link to="/buy" className="nav-link" onClick={closeMenu}>
            PROPERTIES
          </Link>
          <Link to="/about" className="nav-link" onClick={closeMenu}>
            OUR STORY
          </Link>
          <Link to="/blogs" className="nav-link" onClick={closeMenu}>
            BLOGS
          </Link>
          <Link to="/contact" className="nav-link" onClick={closeMenu}>
            CONTACT
          </Link>
          <Link to="/properties" className="btn btn-primary btn-large" onClick={closeMenu}>
            Login
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header; 